var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(this.loading)?_c('div',{staticClass:"cover"},[_c('Loader')],1):_vm._e(),(this.$router.currentRoute.path !== '/thanks')?_c('Navbar',{attrs:{"links":this.links}}):_vm._e(),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }